module.exports = __webpack_public_path__ + "static/media/ess-bg.8fb5fd54.svg";